import { Tabs } from 'antd'
import FeatureFlagsPanel from './FeatureFlagsPanel'
import SegmentsPanel from './SegmentsPanel'

const FeaturesSection = () => (
  <Tabs
    defaultActiveKey="flags"
    items={[
      { key: 'flags', label: 'Feature Flags', children: <FeatureFlagsPanel /> },
      { key: 'segments', label: 'Segments', children: <SegmentsPanel /> },
    ]}
  />
)

export default FeaturesSection
